import { createSlice } from "@reduxjs/toolkit";
export const GeneralSlice = createSlice({
    name: 'packages',
    initialState: {
        packages: [],
    },
    reducers: {
        setPackages: (state, action) => {
            state.packages = action.payload;
        }
    }
})

export const { setPackages } = GeneralSlice.actions;

export default GeneralSlice.reducer;